const steps = [
  { number: "01", label: "Choose the tone", detail: "Light oak, ash, or pale walnut — warm but not dark. The wood should add warmth, not compete with the sofa." },
  { number: "02", label: "Pick the shape", detail: "Round or oval for softer rooms; rectangular for longer, more structured spaces. When in doubt, round is more forgiving." },
  { number: "03", label: "Check the scale", detail: "Two-thirds the length of the sofa, and 40–45cm from the sofa edge. Height should match the sofa seat cushion." },
  { number: "04", label: "Choose the finish", detail: "Matte or oiled over gloss. A natural finish reads as warmer and more considered in a calm neutral room." },
  { number: "05", label: "Style it simply", detail: "A tray, a vase, a candle, and a book. That is all you need. Negative space is part of the design." },
];

export default function WCTFormula() {
  return (
    <section className="max-w-2xl mx-auto px-4 md:px-0 py-16 mb-8">
      <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>The Formula</p>
      <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
        How to Choose the Right Coffee Table in 5 Steps
      </h2>
      <div className="w-12 h-px bg-[#C8BAA8] mb-12" />
      <div className="space-y-8">
        {steps.map((step) => (
          <div key={step.number} className="flex gap-8 items-start">
            <span className="text-[#EDE6DA] text-3xl md:text-4xl flex-shrink-0 leading-none" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>{step.number}</span>
            <div>
              <p className="text-[#2C2825] text-sm mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500 }}>{step.label}</p>
              <p className="text-[#6B5E53] text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>{step.detail}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
